'use strict';

export const isNumeric = val => {
  return /^\d+(\.\d+)?$/.test(val);
};

export const isDef = val => {
  return val !== undefined && val !== null;
};

export const addUnit = value => {
  if (!isDef(value)) {
    return undefined;
  }

  value = String(value);
  return isNumeric(value) ? `${value}px` : value;
};

export const objToStyle = style => {
  let arr = [];
  for (let i in style) {
    arr.push(i + ':' + style[i]);
  }
  arr = arr.join(';');
  return arr;
};

export const trimString = obj => {
  if (obj && obj instanceof Object && Object.keys(obj).length > 0) {
    for (let i in obj) {
      if (typeof obj[i] === 'string') {
        obj[i] = obj[i].trim();
      } else if (obj[i] instanceof Object) {
        obj[i] = trimString(obj[i]);
      }
    }
  }
  return obj;
};

export const isArray = any => {
  return Object.prototype.toString.call(any) === '[object Array]';
};
export const smartNumbers = (val = 0, unit = 'K') => {
  let f = parseInt(val)
  if (!f || unit === false) return val

  if (f < 1000) {
    return f
  } else if (f > 10000 && unit !== 'K') {
    return Math.floor(val / 1000) / 10 + 'W'
  } else {
    return Math.floor(val / 100) / 10 + 'K'
  }
}

// 对象转数组
export const objToArr = obj => {
  return Object.keys(obj).map(key => {
    return { name: obj[key], id: key * 1 };
  });
};
export default {
  isNumeric,
  isDef,
  addUnit,
  objToStyle,
  trimString,
  isArray,
  smartNumbers,
  objToArr,
}
